import React from 'react';
import { bool } from 'prop-types';

import classnames from 'classnames';

// Components
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';

// Styles
import styles from './SearchBar-style.scss';

const SearchButton = ({ hasSearchTerm }) => {
    const iconClasses = classnames(styles.icon, {
        [styles.hasTerm]: hasSearchTerm
    });

    return (
        <button
            className={styles.button}
            type='submit'
            value='Submit'
            data-tn='global-header-search-submit'
        >
            <div className={iconClasses}>
              <SearchIcon/>
            </div>
        </button>
    );
};

SearchButton.propTypes = {
    hasSearchTerm: bool
};

SearchButton.defaultProps = {
    hasSearchTerm: false
};

export default SearchButton;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchButton.jsx